import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";

/**
 * The welcome a Tone Master Pro member sees when they arrive from the Discord announcement —
 * i.e. on `/community/tone-master-pro?discordMigration=true`.
 *
 * It replaces the three-step community onboarding wizard for these arrivals: they have already
 * told us they want to be here by following the link, so asking them to choose a profile
 * visibility before they can read anything is friction we don't need. The caller marks the
 * community as set up for them (see CommunityComponent).
 *
 * Two states:
 *   - signed out → a single call to action that round-trips through login and comes back here,
 *     modal and all, because `redirectToConnect` carries the current path AND query string.
 *   - signed in  → the account Connections panel, embedded compact, so linking happens without
 *     leaving the community. It is handed `returnTo` so the OAuth round trip lands back here
 *     rather than on the account page.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "fui-discord-migration-welcome",
  templateUrl: "discord-migration-welcome.component.html",
  styleUrls: ["discord-migration-welcome.component.scss"],
  standalone: false,
})
export class DiscordMigrationWelcomeComponent extends BaseComponent implements OnInit {
  /** Where to come back to after login or the Discord round trip. Path + query string. */
  @Input() returnTo = "";

  public signedIn = false;

  constructor(
    userService: UserService,
    public appService: AppService,
    public activeModal: NgbActiveModal
  ) {
    super(userService);
  }

  ngOnInit() {
    this.signedIn = !!this.user;
    if (!this.returnTo) this.returnTo = window.location.pathname + window.location.search;
  }

  /**
   * Leaves the app for the Cognito-hosted login. `redirectToConnect(true, …)` captures
   * `location.pathname` + `location.search`, so the member returns to this exact URL —
   * `?discordMigration=true` included — and the modal reopens on arrival.
   */
  signIn() {
    this.appService.redirectToConnect(true, false);
  }

  close() {
    this.activeModal.close();
  }
}
